import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { PantherBlockEntity } from '../../entities/BlockEntity';
import { app } from '../../app';
import { getMatch2AssetPath } from '../../util/assets';

// Panther is the id of milk block
type PantherBlockEffectOptions = {
  entity: PantherBlockEntity;
};

export class PantherBlockEffect {
  private readonly scene: GameScene;
  private readonly entity: PantherBlockEntity;

  constructor(scene: GameScene, options: PantherBlockEffectOptions) {
    this.scene = scene;
    this.entity = options.entity;
  }

  public async animateMilkParticles() {
    const scale = this.entity.c.block.blockId === 'pantherSmall' ? 1 : 2;

    const particles = app.particles.create({
      textures: [getMatch2AssetPath('panther/block.panther.milkdrop.png')],
      rate: 0,
      limit: Math.floor(7 * scale),
      emitterDuration: 0,
      duration: 1,
      velocity: [
        { x: 0, y: -200 },
        { x: 0, y: -500 },
      ],
      scale: [
        { x: 0.6 * scale, y: 0.6 * scale },
        { x: 0.8 * scale, y: 0.9 * scale },
      ],
      behaviors: [
        { type: 'explode', magnitude: [200, 400], applyRotation: true },
        { type: 'gravity', gravity: { x: 0, y: 2000 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });

    const position = this.entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }

  public async animateBreakParticles() {
    const scale = this.entity.c.block.blockId === 'pantherSmall' ? 1 : 2;

    const particles = app.particles.create({
      textures: [getMatch2AssetPath('panther/block.panther.piece.png')],
      rate: 0,
      limit: Math.floor(5 * scale),
      emitterDuration: 0,
      duration: 1,
      velocity: [
        { x: 0, y: -200 },
        { x: 0, y: -500 },
      ],
      scale: [
        { x: 1.1 * scale, y: 1.1 * scale },
        { x: 2.1 * scale, y: 2.1 * scale },
      ],
      behaviors: [
        { type: 'explode', magnitude: [500, 700], applyRotation: true },
        { type: 'gravity', gravity: { x: 0, y: 2000 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic', directionalRotation: true },
      ],
    });

    const position = this.entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }
}
